export default class CopyData {
    constructor() {
        this.btnCopyData = document.querySelectorAll('[data-copy]');
        this.copyData();
    }

    copyData() {
        this.btnCopyData.forEach(btn => {
            btn.addEventListener('click', () => {
                const textToCopy = btn.getAttribute('data-copy');
                if (!textToCopy) return;

                navigator.clipboard.writeText(textToCopy).then(() => {
                    console.log('Texto copiado para o clipboard: ' + textToCopy);

                    // Buscar o label acima do botão (ex: no pai mais próximo com classe relativa)
                    const label = btn.parentElement.querySelector('.labelCopyUrl');

                    if (label) {
                        label.classList.remove('hidden');

                        // Ocultar o label após 5 segundos
                        setTimeout(() => {
                            label.classList.add('hidden');
                        }, 5000);
                    }
                }).catch(err => {
                    console.error('Erro ao copiar o texto: ', err);
                });
            });
        });
    }
}

new CopyData();
